export const MAX_NUMBER = 1000000;
export const MIN_NUMBER = 1;
